<template>
  <!-- Table Container Card -->
  <div>
    <form-wizard
      ref="individualCustomerForm"
      :title="null"
      :subtitle="null"
      layout="vertical"
      :back-button-text="$t('Previous')"
      :next-button-text="$t('Next')"
      class="wizard-vertical mb-3"
    >

      <!-- Personal Information tab -->
      <tab-content
        :title="$t('Personal Information')"
        :before-change="validatePersonal"
      >
        <validation-observer ref="personalInfoRules">
          <b-form>
            <h5 class="section-label mb-2">
              {{ $t('Personal Information') }}
            </h5>
            <b-row class="match-height">
              <b-col md="6">
                <SelectField
                  id="title"
                  v-model="customerInformationFormData.title"
                  :label="$t('Title')"
                  :options="titleOptions"
                  :reduce="option => option.value"
                  :error-name="$t('Title')"
                  rules="required"
                  item="label"
                  :placeholder="$t('Select')"
                />
              </b-col>

              <!-- Last Name -->
              <b-col md="6">
                <InputField
                  id="last-name"
                  v-model="customerInformationFormData.lastName"
                  :label="$t('Last Name')"
                  :placeholder="$t('Enter last name')"
                  type="text"
                  :error-name="$t('Last Name')"
                  rules="required"
                  onpaste="return false;"
                  :is-allow-special-characters="false"
                />
              </b-col>
              <!-- Last Name -->

              <!-- First Name -->
              <b-col md="6">
                <InputField
                  id="first-name"
                  v-model="customerInformationFormData.firstName"
                  :label="$t('First Name')"
                  :placeholder="$t('Enter first name')"
                  type="text"
                  :error-name="$t('First Name')"
                  rules="required"
                  onpaste="return false;"
                  :is-allow-special-characters="false"
                />
              </b-col>
              <!-- First Name -->

              <!-- Other Name -->
              <b-col md="6">
                <InputField
                  id="other-names"
                  v-model="customerInformationFormData.otherNames"
                  :label="$t('Other Names')"
                  :placeholder="$t('Enter other names')"
                  type="text"
                  onpaste="return false;"
                  :is-allow-special-characters="false"
                />
              </b-col>
              <!-- Other Name -->

              <b-col md="6">
                <InputField
                  id="bvn"
                  v-model="customerInformationFormData.bvn"
                  :label="$t('Bank Verification Number (BVN)')"
                  :placeholder="$t('Enter BVN')"
                  type="text"
                  :error-name="$t('BVN')"
                  rules="integer|length:11"
                />
              </b-col>

              <!-- Country -->
              <b-col md="6">
                <SelectField
                  id="country"
                  v-model="customerInformationFormData.nationality"
                  :label="$t('Country')"
                  :options="countryOptions"
                  :reduce="option => option"
                  :error-name="$t('Country')"
                  rules="required"
                  item="label"
                  :placeholder="$t('Select')"
                />
              </b-col>
              <!--  Country -->

              <!-- State -->
              <b-col md="6">
                <SelectField
                  id="state"
                  v-model="customerInformationFormData.state"
                  :label="$t('State/Province')"
                  :options="stateOptions"
                  :reduce="option => option"
                  :error-name="$t('State')"
                  rules="required"
                  item="label"
                  :placeholder="$t('Select')"
                  :set-selected="getLGAByState"
                />

              </b-col>
              <!--  State -->
              <!-- Date of Birth -->
              <b-col md="6">
                <DatePickerField
                  id="date-of-birth"
                  v-model="customerInformationFormData.dateOfBirth"
                  rules="required"
                  :label="$t('Date of Birth')"
                  format="Y-m-d"
                  :error-name="$t('Date of Birth')"
                  :config="datePickerConfig"
                />
              </b-col>
              <!--  Date of Birth -->

              <!-- Age -->
              <!-- <b-col md="6">
                <InputField
                  id="age"
                  v-model="customerInformationFormData.age"
                  :label="$t('Age"
                  :placeholder="$t('Enter Age"
                  type="number"
                  :error-name="$t('Age"
                  rules="required"
                />
              </b-col> -->
              <!-- Age -->

              <!-- Gender -->
              <b-col md="6">
                <SelectField
                  id="gender1"
                  v-model="customerInformationFormData.gender"
                  :label="$t('Gender')"
                  :options="genderOptions"
                  :reduce="option => option.value"
                  item="label"
                  :error-name="$t('Gender')"
                  rules="required"
                  :placeholder="$t('Select')"
                />

              </b-col>
              <!-- Gender -->
              <!-- Marital Status -->
              <b-col md="6">
                <SelectField
                  id="marital-status"
                  v-model="customerInformationFormData.maritalStatus"
                  :label="$t('Marital Status')"
                  :options="maritalStatusOptions"
                  :reduce="option => option.value"
                  :error-name="$t('Marital Status')"
                  rules="required"
                  item="label"
                  :placeholder="$t('Select')"
                />

              </b-col>
              <!-- Marital Status -->

              <!--  Means of Identification -->
              <b-col md="6">
                <SelectField
                  id="means-of-id"
                  v-model="customerInformationFormData.meansOfIdentification"
                  :label="$t('Means of Identification')"
                  :options="meansOfIdOptions"
                  :reduce="option => option.value"
                  :error-name="$t('Means of Identification')"
                  rules="required"
                  item="label"
                  :placeholder="$t('Select')"
                />
              </b-col>
              <!--  Means of Identification -->

              <!-- Means of Identification Number -->
              <b-col md="6">
                <InputField
                  id="id-number"
                  v-model="customerInformationFormData.idNumber"
                  :label="$t('Means of Identification Number')"
                  :placeholder="$t('Enter identification number on your card')"
                  type="text"
                  :error-name="$t('Means of Identification Number')"
                  rules="required"
                />
              </b-col>
              <!-- Means of Identification Number -->

              <!-- Issue Date -->
              <b-col md="6">
                <DatePickerField
                  id="issue-date"
                  v-model="customerInformationFormData.meansOfIdentificationIssueDate"
                  rules="required"
                  :label="$t('Issue Date')"
                  format="Y-m-d"
                  :error-name="$t('Issue Date')"
                  :config="datePickerConfig"
                />
              </b-col>
              <!--  Issue Date -->

              <!-- Expiry Date -->
              <b-col md="6">
                <DatePickerField
                  id="expiry-date"
                  v-model="customerInformationFormData.meansOfIdentificationExpiryDate"
                  rules="required"
                  :label="$t('Expiry Date')"
                  format="Y-m-d"
                  :error-name="$t('Expiry Date')"
                  :config="datePickerConfig"
                />
              </b-col>
              <!--  Expiry Date -->

              <!-- Place of Issue -->
              <b-col md="6">
                <InputField
                  id="place-of-issue"
                  v-model="customerInformationFormData.meansOfIdentificationPlaceOfIssue"
                  :label="$t('Place of Issue')"
                  :placeholder="$t('Enter place of issue')"
                  type="text"
                  :error-name="$t('Place of Issue')"
                  rules="required"
                />
              </b-col>
              <!-- Place of Issue -->
            </b-row>
          <!--  Address -->
          </b-form>
        </validation-observer>
      </tab-content>

      <!-- Contact Details tab -->
      <tab-content
        :title="$t('Contact Details')"
        :before-change="validateContactDetails"
      >
        <validation-observer ref="contactDetailsRules">
          <b-form>
            <h5 class="section-label mb-2">
              {{ $t('Contact Details') }}
            </h5>
            <b-row class="match-height">
              <!-- Phone Number -->
              <b-col md="6">
                <InputField
                  id="phone-number"
                  v-model="customerInformationFormData.phoneNumber"
                  :label="$t('Phone Number')"
                  :placeholder="$t('Enter phone number')"
                  type="number"
                  :error-name="$t('Phone Number')"
                  rules="required|integer|min:7|max:13"
                />
              </b-col>
              <!-- Phone Number -->

              <!-- Email -->
              <b-col md="6">
                <InputField
                  id="email"
                  v-model="customerInformationFormData.email"
                  :label="$t('Email')"
                  :placeholder="$t('Enter email')"
                  type="email"
                />
              </b-col>
              <!--  Email -->
              <!-- LGA/Cities -->
              <b-col md="6">
                <SelectField
                  id="state"
                  v-model="customerInformationFormData.lga"
                  :label="$t('LGA/Cities')"
                  :options="lgaOptions"
                  :reduce="option => option"
                  :error-name="$t('LGA')"
                  rules="required"
                  item="label"
                  :placeholder="$t('Select')"
                />
              </b-col>
              <!--  LGA -->

              <!--  Home Address -->
              <b-col md="12">
                <TextAreaField
                  id="home-address"
                  v-model="customerInformationFormData.address"
                  :label="$t('Address')"
                  :placeholder="$t('Enter home address')"
                  :error-name="$t('Home Address')"
                  rules="required"
                  rows="5"
                />
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </tab-content>

      <!-- Next of Kin Information tab -->
      <tab-content
        :title="$t('Next of Kin')"
        :before-change="validateNextOfKin"
      >
        <validation-observer ref="nextOfKinRules">
          <b-form>
            <h5 class="section-label mb-2">
              {{ $t('Next of Kin Information') }}
            </h5>
            <b-row class="match-height">
              <!-- Name -->
              <b-col md="4">
                <InputField
                  id="name"
                  v-model="customerInformationFormData.nokName"
                  :label="$t('Name')"
                  :placeholder="$t('Enter name')"
                  type="text"
                />
              </b-col>
              <!-- Name -->

              <!-- Email -->
              <b-col md="4">
                <b-form-group>
                  <InputField
                    id="email"
                    v-model="customerInformationFormData.nokEmail"
                    :label="$t('Email')"
                    :placeholder="$t('Enter email')"
                    type="email"
                    :error-name="$t('Email')"
                    rules="email"
                  />
                </b-form-group>
              </b-col>
              <!--  Email -->

              <!-- Phone Number -->
              <b-col md="4">
                <b-form-group>
                  <InputField
                    id="phone-number"
                    v-model="customerInformationFormData.nokPhoneNumber"
                    :label="$t('Phone Number')"
                    :placeholder="$t('Enter phone number')"
                    type="number"
                    :error-name="$t('Phone Number')"
                    rules="integer|min:7|max:11"
                  />
                </b-form-group>
              </b-col>
            <!-- Phone Number -->
            </b-row>

            <b-row class="match-height">
              <!-- Relationship -->
              <b-col md="4">
                <b-form-group>
                  <SelectField
                    id="gender"
                    v-model="customerInformationFormData.nokRelationship"
                    :label="$t('Relationship')"
                    :options="relationshipOptions"
                    :reduce="option => option.value"
                    item="label"
                    :placeholder="$t('Select')"
                    :set-selected="setRelationship"
                  />
                </b-form-group>
              </b-col>
              <!-- Relationship -->

              <!-- Others -->
              <b-col
                v-if="isOtherTypeOfRelationship"
                md="4"
              >
                <b-form-group>
                  <InputField
                    id="relationship-other"
                    v-model="typeOfRelationship"
                    :label="$t('Others')"
                    :placeholder="$t('Enter relationship')"
                    type="text"
                    :error-name="$t('Relationship')"
                    rules="required"
                  />
                </b-form-group>
              </b-col>
              <!-- Others -->

              <!-- Date Of Birth -->
              <b-col md="4">
                <DatePickerField
                  id="nok-date-of-birth"
                  v-model="customerInformationFormData.nokDateOfBirth"
                  :label="$t('Date Of Birth')"
                  format="Y-m-d"
                  :config="datePickerConfig"
                />
              </b-col>
              <!--  Date Of Birth -->

              <!--Gender -->
              <b-col
                md="4"
              >
                <SelectField
                  id="gender"
                  v-model="customerInformationFormData.nokGender"
                  :label="$t('Gender')"
                  :options="genderOptions"
                  :reduce="option => option.value"
                  item="label"
                  :placeholder="$t('Select')"
                />
              </b-col>
              <!-- Gender -->

              <!-- Occupation -->
              <b-col md="4">
                <InputField
                  id="occupation"
                  v-model="customerInformationFormData.nokOccupation"
                  :label="$t('Occupation')"
                  :placeholder="$t('Enter occupation')"
                  type="text"
                />
              </b-col>
              <!-- Occupation -->

            </b-row>

            <!--  Address -->
            <b-row class="match-height">
              <b-col md="12">
                <TextAreaField
                  id="next-of-kin-address"
                  v-model="customerInformationFormData.nokAddress"
                  :label="$t('Address')"
                  :placeholder="$t('Enter address')"
                  rows="5"
                />
              </b-col>
            </b-row>
          <!--  Address -->

          </b-form>
        </validation-observer>
      </tab-content>

      <!-- Employment and Bank Details tab -->
      <tab-content
        :title="$t('Employment Details')"
        :before-change="validateEmployeeDetail"
      >
        <validation-observer ref="employeeDetailRules">
          <b-form>
            <h5 class="section-label mb-2">
              {{ $t('Employment and Bank Details') }}
            </h5>
            <b-row class="match-height">
              <!--Employee ID Type -->
              <b-col
                md="4"
              >
                <SelectField
                  id="employee-id-type"
                  v-model="customerInformationFormData.employeeIDType"
                  :label="$t('Employee ID Type')"
                  :options="employeeTypeOptions"
                  :reduce="option => option"
                  item="label"
                  :placeholder="$t('Select')"
                />
              </b-col>
              <!-- Employee ID Type  -->

              <!-- Employee ID -->
              <b-col md="4">
                <InputField
                  id="employee-id"
                  v-model="customerInformationFormData.employeeID"
                  :label="$t('Employee ID')"
                  :placeholder="$t('Enter employee ID')"
                  type="text"
                />
              </b-col>
              <!-- Employee ID -->

              <!-- Employee Income -->
              <b-col md="4">
                <InputNumberField
                  id="employee-net-income"
                  v-model="customerInformationFormData.employeeIDNetIncome"
                  :label="$t('Net Income')"
                  :placeholder="$t('Enter net Income')"
                  type="text"
                />
              </b-col>
              <!-- Employee Income -->

              <!-- Employer Name -->
              <b-col md="4">
                <InputField
                  id="employer-name"
                  v-model="customerInformationFormData.employerName"
                  :label="$t('Employer Name')"
                  :placeholder="$t('Enter employer name')"
                  type="text"
                />
              </b-col>
              <!-- Employer Name -->

              <!--Ministries, Depts and Agencies -->
              <b-col
                md="4"
              >
                <SelectField
                  id="ministries-dept-agencies"
                  v-model="customerInformationFormData.employeeMDA"
                  :label="$t('Ministries, Depts and Agencies')"
                  :options="employeeMDAOptions"
                  :reduce="option => option"
                  item="label"
                  :placeholder="$t('Select')"
                />
              </b-col>
              <!-- Ministries, Depts and Agencies  -->

              <!-- Pay Date -->
              <b-col md="4">
                <DatePickerField
                  id="pay-date"
                  v-model="customerInformationFormData.employeePayDate"
                  :label="$t('Pay Date')"
                  format="Y-m-d"
                  :config="datePickerConfig"
                />
              </b-col>
              <!--  Pay Date -->

              <!-- State of Employment -->
              <b-col md="4">
                <SelectField
                  id="state-of-employment"
                  v-model="customerInformationFormData.stateOfEmployment"
                  :label="$t('State of Employment')"
                  :options="stateOptions"
                  :reduce="option => option"
                  item="label"
                  :placeholder="$t('Select')"
                  :set-selected="getLGAByState"
                />

              </b-col>
              <!--  State of Employment -->

              <!-- Ministry Local Govt Area -->
              <b-col md="4">
                <SelectField
                  id="state"
                  v-model="customerInformationFormData.ministryOfLGA"
                  :label="$t('Ministry Local Govt Area')"
                  :options="lgaOptions"
                  :reduce="option => option"
                  item="label"
                  :placeholder="$t('Select')"
                />
              </b-col>
              <!--  Ministry Local Govt Area -->

              <!-- Employment Date -->
              <b-col md="4">
                <DatePickerField
                  id="employment-date"
                  v-model="customerInformationFormData.employmentDate"
                  :label="$t('Employment Date')"
                  format="Y-m-d"
                  :config="datePickerConfig"
                />
              </b-col>
              <!--  Employment Date -->
            </b-row>
            <h5 class="section-label mt-3 mb-2">
              {{ $t('External/Commercial Bank Details') }}
            </h5>
            <b-row class="match-height">

              <!-- Bank Name -->
              <b-col md="4">
                <SelectField
                  id="bank-name"
                  v-model="customerInformationFormData.employeeBankName"
                  :label="$t('Bank Name')"
                  :options="bankOptions"
                  :reduce="option => option.value"
                  item="label"
                  :placeholder="$t('Select')"
                />
              </b-col>
              <!-- Bank Name -->

              <!-- Bank Account Name -->
              <b-col md="4">
                <InputField
                  id="account-bank-name"
                  v-model="customerInformationFormData.employeeBankAccountName"
                  :label="$t('Bank Account Name')"
                  :placeholder="$t('Enter Bank Account Name')"
                  type="text"
                />
              </b-col>
              <!-- Bank Account Name -->

              <!-- Bank Account Number -->
              <b-col md="4">
                <InputField
                  id="bank-account-number"
                  v-model="customerInformationFormData.employeeBankAccountNumber"
                  :label="$t('Bank Account Number')"
                  :placeholder="$t('Enter Bank Account Number')"
                  type="number"
                />
              </b-col>
              <!-- Bank Account Number -->
            </b-row>
          </b-form>
        </validation-observer>
      </tab-content>

      <!-- Loan Servicing Account Details tab -->
      <tab-content
        :title="$t('Loan Servicing Details')"
        :before-change="validateLoanServicingDetail"
      >
        <validation-observer ref="loanServicingRules">
          <b-form>
            <h5 class="section-label mb-2">
              {{ $t('Loan Servicing Account Details') }}
            </h5>
            <b-row class="match-height">

              <!-- Account Name -->
              <b-col md="6">
                <InputField
                  id="account-name"
                  v-model="fullName"
                  :label="$t('Account Name')"
                  :placeholder="$t('Enter Account Name')"
                  type="text"
                  rules="required"
                  :error-name="$t('Account Name')"
                />
              </b-col>
              <!-- Account Name -->

              <!-- Branch Name -->
              <b-col md="6">
                <SelectField
                  id="branch-name"
                  v-model="customerAccountFormData.branchCode"
                  :label="$t('Branch')"
                  :options="branchOptions"
                  :reduce="option => option"
                  item="label"
                  :placeholder="$t('Select')"
                  rules="required"
                  :error-name="$t('Branch')"
                  :set-selected="setBranch"
                />
              </b-col>
              <!-- Branch Name -->

              <!-- Branch Name -->
              <b-col md="6">
                <SelectField
                  id="product-type"
                  v-model="customerAccountFormData.productCode"
                  :label="$t('CASA Product Type')"
                  :options="productOptions"
                  :reduce="option => option"
                  item="label"
                  :placeholder="$t('Select')"
                  rules="required"
                  :error-name="$t('CASA Product Type')"
                />
              </b-col>
              <!-- Branch Name -->

              <!-- Account Officer Name -->
              <b-col md="6">
                <SelectField
                  id="account-officer"
                  v-model="customerAccountFormData.accountOfficerCode"
                  :label="$t('Account Officer')"
                  :options="accountOfficerOptions"
                  :reduce="option => option"
                  item="label"
                  rules="required"
                  :error-name="$t('Account Officer')"
                  :placeholder="$t('Select')"
                  :set-selected="setAccountOfficer"
                />
              </b-col>
              <!-- Account Officer Name -->

              <!-- Account Tier Level-->
              <b-col md="6">
                <SelectField
                  id="level-1"
                  v-model="customerAccountFormData.accountTierLevel"
                  :label="$t('Account Tier Level')"
                  :options="formattedAccountTierLevelOptions"
                  :reduce="option => option.value"
                  item="label"
                  :placeholder="$t('Select')"
                />
              </b-col>
            <!-- Account Tier Level-->

            </b-row>
          </b-form>
        </validation-observer>
      </tab-content>

      <!-- Loan Details tab -->
      <tab-content
        :title="$t('Loan Details')"
        :before-change="validateLoanDetail"
      >
        <validation-observer ref="loanDetailRules">
          <b-form>
            <h5 class="section-label mb-2">
              {{ $t('Loan Details') }}
            </h5>
            <b-row class="match-height">
              <!-- Account Name -->
              <b-col md="6">
                <InputField
                  id="account-name"
                  v-model="fullName"
                  :label="$t('Account Name')"
                  :placeholder="$t('Enter Account Name')"
                  type="text"
                  rules="required"
                  :error-name="$t('Account Name')"
                />
              </b-col>
              <!-- Account Name -->

              <!-- Branch Name -->
              <b-col md="6">
                <SelectField
                  id="branch-name"
                  v-model="loanAccountFormData.branchCode"
                  :label="$t('Branch')"
                  :options="branchOptions"
                  :reduce="option => option"
                  item="label"
                  :placeholder="$t('Select')"
                  readonly
                />
              </b-col>
              <!-- Branch Name -->

              <!-- Product Name -->
              <b-col md="6">
                <SelectField
                  id="product-name"
                  v-model="loanAccountFormData.productCode"
                  :label="$t('Loan Product Name')"
                  :options="productLoanOptions"
                  :reduce="option => option"
                  item="label"
                  :placeholder="$t('Select')"
                  rules="required"
                  :error-name="$t('Loan Product Name')"
                />
              </b-col>
              <!-- Product Name -->

              <!-- Account Officer Name -->
              <b-col md="6">
                <SelectField
                  id="account-officer"
                  v-model="loanAccountFormData.accountOfficerCode"
                  :label="$t('Account Officer')"
                  :options="accountOfficerOptions"
                  :reduce="option => option"
                  item="label"
                  :placeholder="$t('Select')"
                  rules="required"
                  :error-name="$t('Account Officer')"
                />
              </b-col>
              <!-- Account Officer Name -->

              <!-- Account Tier Level-->
              <b-col md="6">
                <SelectField
                  id="lending-model"
                  v-model="loanAccountFormData.lendingModel"
                  :label="$t('Lending Model')"
                  :reduce="option => option.value"
                  :options="lendingModelOptions"
                  :placeholder="$t('Select')"
                  item="label"
                  rules="required"
                  :error-name="$t('Lending Model')"
                />
              </b-col>
              <!-- Account Tier Level-->
              <b-col md="6">
                <SelectField
                  id="economic-sector"
                  v-model="loanAccountFormData.economicSector"
                  :label="$t('Economic Sector')"
                  :reduce="option => option"
                  :options="economicSectorOptions"
                  :placeholder="$t('Select')"
                  item="label"
                  rules="required"
                  :error-name="$t('Economic Sector')"
                />
              </b-col>

              <b-col md="6">
                <InputField
                  id="loan-purpose"
                  v-model="loanAccountFormData.loanPurpose"
                  :label="$t('Loan Purpose')"
                  :placeholder="$t('Enter Loan Purpose')"
                  type="text"
                  rules="required"
                  :error-name="$t('Enter Loan Purpose')"
                />
              </b-col>

              <b-col md="6">
                <InputNumberField
                  id="loan-principal"
                  v-model="loanAccountFormData.loanAmount"
                  :label="$t('Loan Principal Amount')"
                  rules="required"
                  :error-name="$t('Loan Principal Amount')"
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="applicable-interest"
                  v-model="loanAccountFormData.applicableInterestCode"
                  :label="$t('Select Applicable Interest')"
                  :reduce="option => option"
                  :options="interestApplicationOptions"
                  :placeholder="$t('Select')"
                  item="label"
                  :set-selected="setApplicableInterest"
                  rules="required"
                  :error-name="$t('Applicable Interest')"
                />
              </b-col>

              <b-col md="6">
                <SwitchButton
                  v-model="loanAccountFormData.useProductInterestRate"
                  :label="$t('Override Product Interest Rate?')"
                  name="use-product-interest-rate"
                  style="text-align: right"
                />
                <InputField
                  v-if="loanAccountFormData.useProductInterestRate"
                  id="applicable-interest-rate"
                  v-model.number="loanAccountFormData.applicableInterestRate"
                  :label="$t('Applicable Interest Rate')"
                  type="number"
                  style="margin-top: -35px;"
                  rules="max-value:100|positive"
                  readonly
                />
                <InputField
                  v-else
                  id="applicable-interest-rate"
                  v-model.number="loanAccountFormData.applicableInterestRate"
                  :label="$t('Applicable Interest Rate')"
                  type="number"
                  style="margin-top: -35px;"
                  rules="max-value:100|positive"
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="interest-repayment-rate"
                  v-model="loanAccountFormData.repaymentOption"
                  :label="$t('Repayment Option')"
                  :reduce="option => option.value"
                  :options="repaymentTypeOptions"
                  :placeholder="$t('Select')"
                  item="label"
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="interest-repayment-frequency"
                  v-model="loanAccountFormData.repaymentFrequency"
                  :label="$t('Repayment Frequency')"
                  :reduce="option => option.value"
                  :options="frequencyOptions"
                  :placeholder="$t('Select')"
                  item="label"
                  :set-selected="computeTenure"
                />
              </b-col>

              <b-col md="6">
                <InputField
                  id="number-of-installment"
                  v-model="loanAccountFormData.numberOfInstallment"
                  :label="$t('Number of Instalments')"
                  type="number"
                  rules="required"
                  :error-name="$t('Number of Instalments')"
                  :on-input="computeTenure"
                />
              </b-col>

              <b-col md="6">
                <InputField
                  id="tenure"
                  v-model.number="loanAccountFormData.tenure"
                  :label="$t('Tenure')"
                  type="number"
                  readonly
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="interest-computation-mode"
                  v-model="loanAccountFormData.interestAccrualMode"
                  :label="$t('Interest Computation Mode')"
                  :reduce="option => option.value"
                  :options="interestAccrualOptions"
                  :placeholder="$t('Select')"
                  :error-name="$t('Interest Computation Mode')"
                  rules="required"
                  item="label"
                />
              </b-col>
            </b-row>

            <b-row class="mt-3">
              <b-col
                cols="12"
                class="mb-2"
              >
                <h5 class="mb-0">
                  {{ $t('Loan Fee Information') }}
                </h5>
              </b-col>

              <b-col md="6">
                <SwitchButton
                  v-model="loanAccountFormData.applyLoanFees"
                  :label="$t('Apply Loan Fee')"
                  name="apply-loan-fee"
                  class="mt-2"
                />
              </b-col>
              <b-col
                v-if="setApplyLoanFee(loanAccountFormData.applyLoanFees)"
                md="6"
              >
                <SelectField
                  id="loan-fee"
                  v-model="loanAccountFormData.loanFees"
                  :label="$t('Loan Fee')"
                  :reduce="option => option.value"
                  :options="loanFeeOptions"
                  :placeholder="$t('Select')"
                  :error-name="$t('Select Loan Fee')"
                  item="label"
                  multiple
                />
              </b-col>
              <b-col md="6">
                <DatePickerField
                  id="start-date"
                  v-model="loanAccountFormData.startDate"
                  :label="$t('Loan Start Date')"
                  rules="required"
                  :error-name="$t('Loan Start Date')"
                  :on-change="setEndDate"
                  :config="datePickerConfig"
                  :placeholder="$t('Select Loan Start Date')"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="interest-accrual"
                  v-model="loanAccountFormData.interestCommencementDate"
                  :label="$t('Interest Accrual Start Date')"
                  type="text"
                  :error-name="$t('Interest Accrual Start Date')"
                  rules="required"
                  readonly
                />
              </b-col>
            </b-row>

            <!-- Loan Moratorium -->
            <b-row class="mt-3">
              <b-col
                cols="12"
                class="mb-2"
              >
                <h5 class="mb-0">
                  {{ $t('Loan Moratorium') }}
                </h5>
              </b-col>

              <b-col md="12">
                <SwitchButton
                  v-model="isIgnoreProductDefault"
                  :label="$t('Ignore Product Default')"
                  name="ignore-product-default"
                  class="mt-2"
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="alow-moratorium-loan"
                  v-model="loanAccountFormData.allowMoratorium"
                  :label="$t('Allow Moratorium On Loan Repayment')"
                  :reduce="option => option.value"
                  :options="moratoriumTypeOptions"
                  :placeholder="$t('Select')"
                  :error-name="$t('Allow Moratorium On Loan Repayment')"
                  :rules="productDefaultRules"
                  item="label"
                  :readonly="!isIgnoreProductDefault"
                  :set-selected="setMoratorium"
                />
              </b-col>
            </b-row>

            <b-row v-if="isAllowMoratorium">
              <b-col
                md="6"
              >
                <SelectField
                  id="moratorium-effect"
                  v-model="loanAccountFormData.moratoriumEffect"
                  :label="$t('Moratorium Effect On Loan Duration')"
                  :reduce="option => option.value"
                  :options="moratoriumEffectOptions"
                  :placeholder="$t('Select')"
                  :error-name="$t('Moratorium Effect On Loan Duration')"
                  :rules="productDefaultRules"
                  item="label"
                  :readonly="!isIgnoreProductDefault"
                />
              </b-col>

              <b-col
                md="6"
              >
                <InputField
                  id="moratorium-duration"
                  v-model.number="loanAccountFormData.moratoriumDuration"
                  :label="$t('Moratorium Duration')"
                  :placeholder="$t('Enter moratorium duration')"
                  type="number"
                  :error-name="$t('Moratorium Duration')"
                  :rules="moratoriumDurationRules"
                  :readonly="!isIgnoreProductDefault"
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="frequency"
                  v-model="loanAccountFormData.moratoriumFrequency"
                  :label="$t('Frequency')"
                  :options="moratoriumFrequencyOptions"
                  :reduce="option => option.value"
                  :placeholder="$t('Select')"
                  :error-name="$t(' Frequency')"
                  :rules="productDefaultRules"
                  item="label"
                  :readonly="!isIgnoreProductDefault"
                />
              </b-col>
            </b-row>

            <b-row v-if="showComputedInterest">
              <b-col
                md="6"
              >
                <TextAreaField
                  id="computed-interest"
                  v-model="computedInterest"
                  :label="$t('Computed Interest')"
                  type="text"
                  rows="2"
                  readonly
                />
              </b-col>
            </b-row>

            <div class="d-flex flex-wrap">
              <Button
                v-if="actionType !== 'view'"
                :label="$t('Compute Interest')"
                :loading="isLoadingComputeInterest"
                :disabled="isDisabledComputeInterest"
                size="sm"
                class="mt-3 mb-2"
                @click="computeInterest"
              />

              <Button
                v-if="actionType !== 'view'"
                :label="$t('View Repayment Schedule')"
                :loading="isLoadingComputeInterest"
                :disabled="isDisabledComputeInterest"
                size="sm"
                class="mt-3 mb-2 ml-lg-2 ml-md-2"
                @click="onViewRepaymentSchedule"
              />
            </div>
          </b-form>
        </validation-observer>
      </tab-content>

      <!-- Other Documents tab-->
      <tab-content
        :title="$t('Other Documents')"
        :before-change="validatUploads"
      >
        <validation-observer ref="uploadRules">
          <b-form>
            <div>
              <div class="w-full mt-4 p-10">
                <div class="d-flex mb-0 mt-2 align-items-center justify-content-between">
                  <h4>{{ $t('Other Documents Upload') }}</h4>

                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="ml-4"
                    @click="addNewDocument()"
                  >
                    <feather-icon
                      icon="PlusIcon"
                      class="mr-25"
                    />
                    <span>{{ $t('Add New Document') }}</span>
                  </b-button>
                </div>
                <b-row
                  v-for="(item, index) in documentsFormData"
                  :id="index"
                  :key="index"
                  class="mb-2"
                >
                  <b-col md="6">
                    <SelectField
                      id="document-type"
                      v-model="item.type"
                      :reduce="option => option.value"
                      :label="$t('Document Type')"
                      :placeholder="$t('Select')"
                      :options="formattedDocumentTypeOptions"
                      :error-name="$t('Document Type')"
                      rules="required"
                      item="label"
                    />
                  </b-col>
                  <b-col
                    md="7"
                  >
                    <label>{{ $t('Upload Documents') }}</label>

                    <div class="upload-image">
                      <Spinner :show="documentLoadSpinner" />
                      <b-form-group>
                        <b-form-file
                          :placeholder="$t('Choose a file or drop it here...')"
                          :drop-placeholder="$t('Drop file here...')"
                          accept="image/jpeg, image/png, image/jpg, application/pdf, .doc, .docx, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                          plain
                          @change="onDocumentsUpload(index, $event)"
                        />
                        <div
                          v-if="!item.url"
                          class="upload-instruction"
                        >
                          <h4>{{ $t('Upload Document File') }}</h4>
                          <p>{{ $t('Drag & drop file or choose from your device to upload') }}</p>
                          <p class="format">
                            {{ $t('Format accepted') }} (jpg, png, jpeg, docx, pdf)
                          </p>
                        </div>
                        <div v-else>
                          <div v-if="item.fileExtension === 'png'|| item.fileExtension === 'jpeg'|| item.fileExtension === 'jpg'">
                            <b-img
                              :src="item.url"
                              block
                              rounded
                              width="250px"
                              height="250px"
                            />
                          </div>
                          <div
                            v-if="item.fileExtension === 'pdf'"
                          >
                            <b-img
                              :src="pdfIcon"
                              block
                              rounded
                              width="250px"
                              height="250px"
                            />
                          </div>
                          <div
                            v-else-if="item.fileExtension === 'vnd'"
                          >
                            <b-img
                              :src="wordIcon"
                              block
                              rounded
                              width="250px"
                              height="250px"
                            />
                          </div>
                          <div
                            v-else
                          >
                            <b-img
                              src=""
                            />
                          </div>
                          <div
                            v-if="item.url"
                            class="trash"
                          >
                            <feather-icon
                              icon="Trash2Icon"
                              size="20"
                              class="text-primary"
                              @click="deleteDocumentFile(item.id, index)"
                            />
                          </div>
                          <div
                            v-if="item.url"
                            class="view-details"
                          >
                            <feather-icon
                              icon="EyeIcon"
                              size="20"
                              class="text-primary"
                              @click="viewDocumentFile(item.url, item.fileName, item.fileExtension)"
                            />
                          </div>
                          <!-- </div> -->
                        </div>
                      </b-form-group>
                    </div>
                  </b-col>
                  <b-col
                    md="3"
                    class="mt-0"
                  >
                    <b-row>
                      <!-- Remove Button -->
                      <b-col
                        md="12"
                        class="mt-1"
                      >
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="primary"
                          class="ml-0"
                          @click="removeDocument(item.id, index)"
                        >
                          <feather-icon
                            icon="XIcon"
                            class="mr-25"
                          />
                          <span>{{ $t('Remove') }}</span>
                        </b-button>
                      </b-col>
                      <b-col
                        md="12"
                        class="mt-1"
                      >
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="primary"
                          class="ml-0"
                          @click="handleDownload(item.url)"
                        >
                          <feather-icon
                            icon="DownloadIcon"
                            class="mr-25"
                          />
                          <span>{{ $t('Download') }}</span>
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-form>
        </validation-observer>
      </tab-content>

      <template
        slot="finish"
      >
        <div class="wizard-footer-right">
          <Button
            :label="$t('Save')"
            :loading="isLoading"
            :disabled="isDisabled"
            size="lg"
            @click="handleSubmit"
          />
        </div>

      </template>
      <FullScreenSpinner :show="showSpinner" />
    </form-wizard>

    <b-modal
      id="repayment-schedule-modal"
      ref="repaymentScheduleModal"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      centered
      size="lg"
      :title="$t('Repayment Schedule')"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >

            <TableEntries
              v-model="repaymentSchedulePagination.perPage"
              :options="perPageOptions"
            />

          </b-col>

          <!-- Export -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-dropdown
                id="dropdown-1"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                :text="$t('Export')"
                variant="primary"
              >
                <b-dropdown-item @click="csvExport(csvData)">
                  CSV
                </b-dropdown-item>
                <b-dropdown-item @click="excelExport(csvData)">
                  Excel
                </b-dropdown-item>
                <b-dropdown-item @click="pdfExport">
                  PDF
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </b-col>

        </b-row>

      </div>

      <b-table
        ref="repaymentScheduleModalTable"
        select-mode="single"
        :items="repaymentSchedules"
        responsive
        no-local-sorting
        :fields="translatedRepaymentScheduleTableHeaders"
        :per-page="repaymentSchedulePagination.perPage"
        :current-page="repaymentSchedulePagination.currentPage"
        primary-key="id"
        show-empty
        :empty-text="$t('No result found')"
        class="position-relative mt-2"
      >
        <template #cell(SN)="data">
          {{ getPageNumber(data.index) }}
        </template>
      </b-table>

      <TablePagination
        v-model="repaymentSchedulePagination.currentPage"
        :from="repaymentFrom"
        :to="repaymentTo"
        :total-rows="repaymentSchedulePagination.totalEntries"
        :per-page="repaymentSchedulePagination.perPage"
      />

      <template
        #modal-footer="{ }"
      >
        <div />
      </template>
    </b-modal>
    <b-modal
      id="view-avatar-modal"
      ref="avatarModal"
      no-close-on-backdrop
      :ok-title="$t('Download File')"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      centered
      size="lg"
      :title="viewDocumentModalTitle"
      @hidden="resetDocumentModal"
      @cancel="resetDocumentModal"
      @ok="handleDownload(viewDocumentData)"
    >
      <div class="m-2 text-center">
        <b-row>
          <b-col cols="12">
            <div v-if="fileExtension === 'png'|| fileExtension === 'jpeg'|| fileExtension === 'jpg'">
              <b-img
                :src="viewDocumentData"
                block
                fluid
                rounded
              />
            </div>
            <div v-else-if="fileExtension === 'pdf'">
              <b-img
                :src="pdfIcon"
                block
                width="250px"
                height="250px"
                rounded
              />
            </div>
            <div v-else-if="fileExtension === 'vnd'">
              <b-img
                :src="wordIcon"
                block
                width="250px"
                height="250px"
                rounded
              />
            </div>
            <div v-else>
              <b-img
                src=""
              />
            </div>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BButton,
  BForm, BFormFile, BImg, BDropdown, BDropdownItem, BTable,
} from 'bootstrap-vue'
import { FormWizard, TabContent } from 'vue-form-wizard'
import { ValidationObserver } from 'vee-validate'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { required } from '@validations'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import { permissionMixin } from '@core/mixins/permission'
import Ripple from 'vue-ripple-directive'
import { mapActions, mapGetters } from 'vuex'
import { v4 as uuidv4 } from 'uuid'
import addSpaceToString from '../../../../helpers/addSpaceToString'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import TablePagination from '@/views/components/table/TablePagination.vue'
import TableEntries from '@/views/components/table/TableEntries.vue'
import Spinner from '@/views/components/spinner/Spinner.vue'
import InputField from '../../../forms/InputField.vue'
import InputNumberField from '../../../forms/InputNumberField.vue'
import TextAreaField from '../../../forms/TextAreaField.vue'
import SelectField from '../../../forms/SelectField.vue'
import DatePickerField from '../../../forms/DatePickerField.vue'
import getEndDate from '../../../../helpers/getEndDate'
import { exportToCSV, exportToExcel, exportToPDF } from '@/helpers/export'
import { toBalance, toKobo, formatAmount } from '@/helpers/formatAmount'
import { toYearWithDate, toDateWithMonth } from '../../../../helpers/formatDate'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import Button from '../../../components/button/Button.vue'
import SwitchButton from '../../../components/switch/Switch.vue'
import {
  gender, pdfIcon, wordIcon, titleOptions, countries, religionOptions, meansOfIdOptions,
  maritalStatusOptions, relationshipOptions, ministriesDepartmentAgencies, industrialSectorsAndCod,
  lendingModel, repaymentTypes, repaidFrequencies, interestAccruals, moratoriumEffect, moratoriumType,
} from '../../../../helpers/data'
import { accountPermissions } from '../../../../helpers/permissions'

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BFormFile,
    FormWizard,
    TabContent,
    BFormGroup,
    BForm,
    BButton,
    ValidationObserver,
    InputField,
    InputNumberField,
    TextAreaField,
    SelectField,
    DatePickerField,
    Button,
    TablePagination,
    TableEntries,
    FullScreenSpinner,
    Spinner,
    SwitchButton,
    BDropdown,
    BDropdownItem,
    BTable,
  },
  directives: {
    Ripple,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, permissionMixin],
  data() {
    return {
      documentsFormData: [{
        type: '',
        url: '',
        file: '',
      }],
      viewDocumentData: '',
      viewDocumentModalTitle: '',
      fileExtension: '',
      documentLoadSpinner: false,
      documentTypeOptions: [
        { value: 1, label: 'Signature Specimen' },
        { value: 2, label: 'Proof Of Address' },
        { value: 3, label: 'Driver’s License' },
        { value: 4, label: 'National Identity Card' },
        { value: 5, label: 'Voters Card' },
        { value: 6, label: 'National Identity Number' },
        { value: 7, label: 'International Passport' },
        { value: 8, label: 'Passport Photograph' },
        { value: 9, label: 'Reference Letter' },
        { value: 10, label: 'Guarantor’s Letter' },
        { value: 11, label: 'Loan Application Form' },
        { value: 12, label: 'Credit Bureau Form' },
        { value: 13, label: 'Others' },
      ],
      documentIdentifier: '',
      isReadonly: true,
      isBusy: false,
      showSpinner: false,
      isDisabled: false,
      isLoading: false,
      required,
      formatAmount,
      buttonAction: 'Save',
      imageFormData: {
        onboardingPageBackgroundURL: '',
        loginPageImageUrl: '',
        logoURL: '',
        onboardingNavBackgroundImageURL: '',
        faviconURL: '',
      },

      isIgnoreProductDefault: false,
      isAllowMoratorium: false,
      showComputedInterest: false,
      isLoadingComputeInterest: false,
      isDisabledComputeInterest: false,
      isLoadingRepaymentSchedule: false,
      isDisabledRepaymentSchedule: false,
      productDefaultRules: '',
      rules: '',
      moratoriumDurationRules: '',
      moratoriumEffectOptions: moratoriumEffect,
      moratoriumFrequencyOptions: repaidFrequencies,
      // moratoriumTypeOptions: moratoriumType,

      typeOfRelationship: '',
      // genderOptions: gender,
      isOtherTypeOfRelationship: false,
      actionType: 'save',
      country: '',
      pdfIcon,
      wordIcon,
      // titleOptions,
      religionOptions,
      // meansOfIdOptions,
      // maritalStatusOptions,
      // relationshipOptions,
      datePickerConfig: {
        dateFormat: 'd/m/Y',
        ariaDateFormat: 'd/m/Y',
      },
      lgaOptions: [],
      nationalityOptions: [],
      countryOptions: ['Nigeria'],
      employeeTypeOptions: [
        'IPPIS Number', 'Oracle Number', 'Private Staff ID',
      ],
      accountTierLevelOptions: [
        { label: 'Tier 1', value: 1 },
        { label: 'Tier 2', value: 2 },
        { label: 'Tier 3', value: 3 },
      ],
      employeeMDAOptions: ministriesDepartmentAgencies,
      productOptions: [],
      productLoanOptions: [],
      accountOfficerOptions: [],
      annualRepaymentFrequency: '',
      customerInformationFormData: {
        title: '',
        lastName: '',
        firstName: '',
        otherNames: '',
        bvn: '',
        state: '',
        nationality: '',
        dateOfBirth: null,
        gender: '',
        maritalStatus: '',
        meansOfIdentification: '',
        idNumber: '',
        meansOfIdentificationIssueDate: null,
        meansOfIdentificationExpiryDate: null,
        meansOfIdentificationPlaceOfIssue: '',
        phoneNumber: '',
        email: '',
        address: '',
        lga: '',
        nokName: '',
        nokDateOfBirth: null,
        nokAddress: '',
        nokGender: '',
        nokOccupation: '',
        nokRelationship: '',
        nokPhoneNumber: '',
        nokEmail: '',
        employeeIDType: '',
        employeeID: '',
        employeeIDNetIncome: null,
        employerName: '',
        employeeMDA: '',
        employeePayDate: null,
        stateOfEmployment: '',
        ministryOfLGA: '',
        employmentDate: null,
        employeeBankName: '',
        employeeBankAccountName: '',
        employeeBankAccountNumber: '',
      },

      customerAccountFormData: {
        productCode: '',
        accountOfficerCode: '',
        branchCode: '',
        accountTierLevel: '',
      },

      loanAccountFormData: {
        productCode: '',
        accountOfficerCode: '',
        branchCode: '',
        lendingModel: '',
        economicSector: '',
        loanPurpose: '',
        loanAmount: 0,
        applicableInterestCode: '',
        useProductInterestRate: true,
        applicableInterestRate: 0,
        repaymentOption: '',
        repaymentFrequency: '',
        toBeRepaidEvery: 0,
        numberOfInstallment: 0,
        tenure: 0,
        interestAccrualMode: '',
        startDate: null,
        applyLoanFees: false,
        accountCreationChannel: '',
        interestCommencementDate: null,
        loanFees: [],
        // principalInstallment: '',
        allowMoratorium: '',
        moratoriumDuration: 0,
        moratoriumFrequency: '',
        moratoriumEffect: '',
        securityDeposit: 0,
        holdFundSecurityDeposit: false,
        collateralType: '',
        collateralValuation: 0,
        collateralDescription: '',
        guarantorID1: '',
        guarantorID2: '',
        penaltyGracePeriod: 0,
        hasCollateralPledge: false,
      },
      // lendingModelOptions: lendingModel,
      // economicSectorOptions: industrialSectorsAndCod,
      // repaymentTypeOptions: repaymentTypes,
      // frequencyOptions: repaidFrequencies,
      // interestAccrualOptions: interestAccruals,
      interestApplicationOptions: [],
      loanFeeOptions: [],
      repaymentSchedules: [],
      newRepaymentSchedules: [],

      repaymentSchedulePagination: {
        currentPage: 1,
        totalEntries: 0,
        perPage: 10,
        pageSize: 0,
      },

      repaymentScheduleTableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'paymentDate', sortable: true, label: 'Repayment Date' },
        { key: 'principal', sortable: true, label: 'Principal' },
        { key: 'interest', sortable: true, label: 'Interest' },
        { key: 'fee', sortable: true, label: 'Loan Fee' },
        { key: 'totalRepayment', sortable: true, label: 'Total Repayment' },
        { key: 'paymentStatus', sortable: true, label: 'Payment Status' },
      ],
      imagePath: {
        size: '',
        height: '',
        width: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      branchOptions: 'operations/branchOptions',
      bankOptions: 'operations/bankOptions',
      corporateInformation: 'operations/getCorporateDetails',
    }),
    fullName: {
      get() {
        return `${this.customerInformationFormData.lastName ?? ''} ${this.customerInformationFormData.firstName ?? ''} ${this.customerInformationFormData.otherNames ?? ''}`
      },
      set(newValue) {
        return newValue
      },
    },
    stateOptions() {
      const country = countries.find(item => item.name === 'Nigeria')
      return country.states.map(item => item.state).sort()
    },
    repaymentFrom() {
      return (this.repaymentSchedulePagination.currentPage * this.repaymentSchedulePagination.perPage) - (this.repaymentSchedulePagination.perPage - 1)
    },
    repaymentTo() {
      return Math.min(this.repaymentFrom + this.repaymentSchedulePagination.perPage - 1, this.repaymentSchedulePagination.totalEntries)
    },
    csvData() {
      return this.newRepaymentSchedules.map(item => ({
        'Repayment Date': item.paymentDate,
        Principal: toBalance(item.principal),
        Interest: toBalance(item.interest),
        'Loan Fee': toBalance(item.fee),
        'Total Repayment': toBalance(item.totalRepayment),
        'Payment Status': item.paymentStatus,
      }))
    },
    formattedDocumentTypeOptions() {
      return this.documentTypeOptions.map(item => ({ label: this.$t(item.label), value: item.value }))
    },
    titleOptions() {
      return titleOptions.map(item => ({ label: this.$t(item.label), value: item.value }))
    },
    genderOptions() {
      return gender.map(item => ({ label: this.$t(item.label), value: item.value }))
    },
    maritalStatusOptions() {
      return maritalStatusOptions.map(item => ({ label: this.$t(item.label), value: item.value }))
    },
    meansOfIdOptions() {
      return meansOfIdOptions.map(item => ({ label: this.$t(item.label), value: item.value }))
    },
    relationshipOptions() {
      return relationshipOptions.map(item => ({ label: this.$t(item.label), value: item.value }))
    },
    formattedAccountTierLevelOptions() {
      return this.accountTierLevelOptions.map(item => ({ label: this.$t(item.label), value: item.value }))
    },
    lendingModelOptions() {
      return lendingModel.map(item => ({ label: this.$t(item.label), value: item.value }))
    },
    economicSectorOptions() {
      return industrialSectorsAndCod.map(item => ({ label: this.$t(item.label), value: item.value }))
    },
    translatedRepaymentScheduleTableHeaders() {
      return this.repaymentScheduleTableHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
    frequencyOptions() {
      return repaidFrequencies.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.value }))
    },
    repaymentTypeOptions() {
      return repaymentTypes.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.value }))
    },
    interestAccrualOptions() {
      return interestAccruals.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.value }))
    },
    moratoriumTypeOptions() {
      return moratoriumType.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.value }))
    },
  },
  watch: {
    isIgnoreProductDefault(newValue) {
      if (newValue === true) {
        this.productDefaultRules = 'required'
        this.moratoriumDurationRules = 'required|integer|positive'
      } else {
        this.productDefaultRules = ''
        this.moratoriumDurationRules = ''
        this.loanAccountFormData.allowMoratorium = ''
        this.loanAccountFormData.moratoriumEffect = ''
        this.loanAccountFormData.moratoriumDuration = 0
        this.loanAccountFormData.moratoriumFrequency = ''
      }
    },
    repaymentScheduleCurrentPage(newValue) {
      this.repaymentSchedulePagination.currentPage = newValue
    },
    repaymentSchedulePerPage(newValue) {
      this.repaymentSchedulePagination.perPage = newValue
    },
  },
  mounted() {
    this.documentIdentifier = uuidv4()
    this.fetchCASAProducts()
    this.fetchLoanProducts()
    this.fetchAccountOfficers()
    this.fetchInterestApplicable()
    this.fetchInterestInformation()
    this.fetchLoanFee()
  },
  methods: {
    ...mapActions({
      getCASAProduct: 'account/getProducts',
      getLoanProduct: 'account/getProducts',
      getAccountOfficers: 'account/getAccountOfficerList',
      getInterestApplicable: 'account/getInterestList',
      getInterestInformation: 'operations/getInterestInformationList',
      getLoanFees: 'account/getLoanFeeList',
      getComputedInterest: 'account/getComputedInterest',
      getPaymentSchedule: 'account/getPaymentSchedule',
      uploadDocumentImages: 'account/uploadDocumentImagesAction',
      deleteDocumentsUpload: 'account/deleteDocumentsUploadAction',
      createAbridgeLoanAccount: 'account/createAbridgeLoanAccountAction',
    }),

    addNewDocument() {
      this.documentsFormData.push({
        type: '',
        url: '',
        file: '',
      })
    },
    viewDocumentFile(image, title, fileExtension) {
      this.fileExtension = fileExtension
      this.viewDocumentData = image
      this.viewDocumentModalTitle = title.replace(/([a-zA-Z])(?=[A-Z])/g, '$1 ')
      this.$root.$emit('bv::show::modal', 'view-avatar-modal')
    },
    resetDocumentModal() {
      this.viewDocumentData = ''
      this.viewDocumentModalTitle = ''
    },
    handleDownload(data) {
      const link = document.createElement('a')
      link.href = data
      link.click()
      this.alertSuccess({ text: this.$t('Your request to download file was successful') })
    },
    async removeDocument(id, index) {
      try {
        this.documentLoadSpinner = true
        const formData = new FormData()
        formData.append('id', id)
        const response = await this.deleteDocumentsUpload({ formData, permission: accountPermissions.VIEW_ABRIDGED_LOAN })
        const { status } = response
        if (status === 200) {
          this.documentLoadSpinner = false
          this.documentsFormData.splice(index, 1)
          this.alertSuccess({ text: this.$t('Document Removed') })
        }
      } catch (error) {
        const text1 = this.$t('Delete failed, Reason:')
        error.response.data.errors.forEach(responseError => {
          this.alertError({ text: `${text1} ${responseError.errorMessage}` })
        })
      } finally {
        this.documentLoadSpinner = false
      }
    },
    async deleteDocumentFile(id, index) {
      try {
        this.documentLoadSpinner = true
        const formData = new FormData()
        formData.append('id', id)
        const response = await this.deleteDocumentsUpload({ formData, permission: accountPermissions.VIEW_ABRIDGED_LOAN })
        const { status } = response
        if (status === 200) {
          this.documentsFormData[index].url = ''
          this.documentLoadSpinner = false
          this.alertSuccess({ text: this.$t('Document Deleted') })
        }
      } catch (error) {
        error.response.data.errors.forEach(responseError => {
          this.alertError({ text: `Delete failed, Reason: ${responseError.errorMessage}` })
        })
      } finally {
        this.documentLoadSpinner = false
      }
    },

    async onDocumentsUpload(index, event) {
      try {
        this.documentLoadSpinner = true
        const { files } = event.target

        const formData = new FormData()
        formData.append('attachedFile', files[0])
        formData.append('type', this.documentsFormData[index].type)
        formData.append('referenceNumber', this.documentIdentifier)
        const response = await this.uploadDocumentImages({ formData, permission: accountPermissions.VIEW_ABRIDGED_LOAN })
        const { status, data } = await response
        if (status === 200 && data) {
          this.documentsFormData[index].url = data.url
          this.documentsFormData[index].id = data.id
          this.documentsFormData[index].fileExtension = data.fileExtension
          this.documentLoadSpinner = false
        }
      } catch (error) {
        const text2 = this.$t('Your request to upload image failed. Reason:')
        error.response.data.errors.forEach(responseError => {
          this.alertError({ text: this.$t(`${text2} ${responseError.errorMessage}`) })
        })
      } finally {
        this.documentLoadSpinner = false
      }
    },
    setBranch(code) {
      this.loanAccountFormData.branchCode = code
    },
    setAccountOfficer(code) {
      this.loanAccountFormData.accountOfficerCode = code
    },
    getLGAByState(selectedValue) {
      const country = countries.find(item => item.name === 'Nigeria')
      const selectedState = country.states.find(item => item.state === selectedValue)
      this.lgaOptions = selectedState.lgas.sort()
    },
    setRelationship(selectedValue) {
      if (selectedValue === 'Others') {
        this.isOtherTypeOfRelationship = true
      } else {
        this.isOtherTypeOfRelationship = false
        this.typeOfRelationship = ''
      }
    },
    setMoratorium(selectedValue) {
      if (selectedValue === 'False') {
        this.isAllowMoratorium = false
        this.moratoriumEffect = null
        this.moratoriumDuration = null
        this.moratoriumFrequency = null
      } else {
        this.isAllowMoratorium = true
      }
    },

    async fetchCASAProducts() {
      try {
        const response = await this.getCASAProduct({
          search: { type: 'Savings' },
          page: 0,
          limit: 0,
          permission: accountPermissions.VIEW_ABRIDGED_LOAN,
        })
        const { status, data } = response
        if (status === 200 && data.data) {
          this.productOptions = data.data.filter(dataItem => dataItem.status === 'Active').map(item => ({ label: item.name, value: item.code }))
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.isBusy = false
      }
    },
    async fetchLoanProducts() {
      try {
        const response = await this.getLoanProduct({
          search: { type: 'Loan' },
          page: 0,
          limit: 0,
          permission: accountPermissions.VIEW_ABRIDGED_LOAN,
        })
        const { status, data } = response
        if (status === 200 && data.data) {
          this.productLoanOptions = data.data.filter(dataItem => dataItem.status === 'Active').map(item => ({ label: item.name, value: item.code }))
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.isBusy = false
      }
    },

    async fetchAccountOfficers() {
      try {
        const { data, status } = await this.getAccountOfficers({
          search: '',
          page: 0,
          limit: 0,
          permission: accountPermissions.VIEW_ABRIDGED_LOAN,
        })

        if (status === 200 && data.data) {
          this.accountOfficerOptions = data.data.filter(item => item.status === 'Active').map(item => ({ label: item.name, value: item.staffID }))
        }
      } catch (error) {
        this.alertError({ text: error })
      }
    },

    async fetchInterestApplicable() {
      try {
        const response = await this.getInterestApplicable({
          search: { type: 'Debit' },
          page: 0,
          limit: 0,
          permission: accountPermissions.VIEW_ABRIDGED_LOAN,
        })
        const { status, data } = response
        if (status === 200) {
          this.interestApplicationOptions = data.data.filter(dataItem => dataItem.status === 'Active').map(item => ({
            label: `${item.name} - ${item.rate}%`,
            value: item.code,
          }))
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.isBusy = false
      }
    },

    setEndDate(dateStr) {
      const selectedDate = Array.isArray(dateStr) ? dateStr[0] : dateStr
      this.loanAccountFormData.interestCommencementDate = getEndDate(selectedDate, 1)
    },
    getPageNumber(index) {
      return (this.repaymentSchedulePagination.currentPage * this.repaymentSchedulePagination.perPage) - this.repaymentSchedulePagination.perPage + index + 1
    },
    csvExport() {
      const arrData = this.newRepaymentSchedules.map(item => ({
        'Repayment Date': item.paymentDate,
        Principal: formatAmount(item.principal),
        Interest: formatAmount(item.interest),
        'Loan Fee': formatAmount(item.fee),
        'Total Repayment': formatAmount(item.totalRepayment),
        'Payment Status': item.paymentStatus,
      }))
      exportToCSV({ arrData, institutionName: this.corporateInformation.registeredName, fileName: this.$t('Repayment Schedule') })
    },
    excelExport(arrData) {
      exportToExcel({
        arrData, institutionName: this.corporateInformation.registeredName, fileName: this.$t('Repayment Schedule'),
      })
    },

    pdfExport() {
      const columnsHeader = [
        { title: 'Repayment Date', key: 'paymentDate' },
        { title: 'Principal', key: 'principal' },
        { title: 'Interest', key: 'interest' },
        { title: 'Loan Fee', key: 'fee' },
        { title: 'Total Repayment', key: 'totalRepayment' },
        { title: 'Payment Status', key: 'paymentStatus' },
      ]
      const columns = columnsHeader.map(header => ({ ...header, title: header.title ? this.$t(header.title) : header.key }))
      exportToPDF({
        arrData: this.repaymentSchedules,
        columns,
        institutionName: this.corporateInformation.registeredName,
        fileName: 'Repayment Schedule.pdf',
      })
    },
    async setApplicableInterest(selectedValue) {
      try {
        const response = await this.getInterestApplicable({
          search: { code: selectedValue.value },
          page: 0,
          limit: 0,
          permission: accountPermissions.VIEW_ABRIDGED_LOAN,
        })
        const { status, data } = await response
        if (status === 200) {
          this.loanAccountFormData.applicableInterestRate = data.data[0].rate
        }
      } catch (error) {
        this.toastAlert({ title: error })
      }
    },

    async fetchInterestInformation() {
      try {
        const response = await this.getInterestInformation({
          permission: this.permission,
        })
        const { status, data } = response
        if (status === 200 && data.data) {
          this.annualRepaymentFrequency = data.data.numberOfAccruingInterestDaysInAYear
        }
      } catch (error) {
        this.alertError({ text: error })
      }
    },

    computeTenure(value) {
      this.loanAccountFormData.numberOfInstallment = value
      if (this.loanAccountFormData.repaymentFrequency && this.loanAccountFormData.numberOfInstallment) {
        let frequency
        if (this.loanAccountFormData.repaymentFrequency === 'Daily') {
          frequency = 1
        }
        if (this.loanAccountFormData.repaymentFrequency === 'Weekly') {
          frequency = 7
        }
        if (this.loanAccountFormData.repaymentFrequency === 'Monthly') {
          frequency = 30
        }
        if (this.loanAccountFormData.repaymentFrequency === 'Annually') {
          frequency = this.annualRepaymentFrequency
        }
        this.loanAccountFormData.tenure = this.loanAccountFormData.numberOfInstallment * frequency
      }
    },

    async computeInterest() {
      try {
        if (this.loanAccountFormData.applyLoanFees && !this.loanAccountFormData.loanFees.length) {
          this.alertError({ text: this.$t('Please select applicable loan fees') })
        } else {
          this.showSpinner = true
          const loanFees = this.loanAccountFormData.loanFees.length
            ? this.loanAccountFormData.loanFees.map(item => {
              if (typeof item !== 'object') {
                return { loanFeeCode: item }
              }
              return { loanFeeCode: item.value }
            }) : []
          const response = await this.getComputedInterest({
            permission: accountPermissions.VIEW_ABRIDGED_LOAN,
            formData: {
              accountNumber: this.loanAccountFormData.accountNumber,
              name: this.loanAccountFormData.customerName,
              customerID: this.loanAccountFormData.customerID,
              productCode: this.loanAccountFormData.productCode.toString(),
              linkedNumber: this.loanAccountFormData.linkedNumber,
              principalToBeRepaidEvery: this.loanAccountFormData.toBeRepaidEvery ? this.loanAccountFormData.toBeRepaidEvery : 1,
              principalInstallment: this.loanAccountFormData.numberOfInstallment,
              interestToBeRepaidEvery: this.loanAccountFormData.toBeRepaidEvery ? this.loanAccountFormData.toBeRepaidEvery : 1,
              interestInstallment: this.loanAccountFormData.numberOfInstallment,
              penaltyGracePeriod: this.loanAccountFormData.penaltyGracePeriod,
              loanAmount: toKobo(this.loanAccountFormData.loanAmount),
              approvedDate: this.loanAccountFormData.approvedDate,
              interestCommencementDate: this.loanAccountFormData.interestCommencementDate ? toYearWithDate(this.loanAccountFormData.interestCommencementDate) : null,
              startDate: toYearWithDate(this.loanAccountFormData.startDate),
              firstRepaymentDate: this.loanAccountFormData.firstRepaymentDate ? toYearWithDate(this.loanAccountFormData.firstRepaymentDate) : null,
              endDate: this.loanAccountFormData.endDate,
              principalRepaymentType: this.loanAccountFormData.repaymentOption,
              principalFrequency: this.loanAccountFormData.repaymentFrequency,
              applicableInterestCode: this.loanAccountFormData.applicableInterestCode.value.toString(),
              useProductInterestRate: this.loanAccountFormData.useProductInterestRate,
              applicableInterestRate: this.loanAccountFormData.applicableInterestRate,
              defaultingInterestRate: this.loanAccountFormData.defaultingInterestRate,
              interestRepaymentType: this.loanAccountFormData.repaymentOption,
              interestFrequency: this.loanAccountFormData.repaymentFrequency,
              interestAccrualMode: this.loanAccountFormData.interestAccrualMode,
              interestFreePrincipalAmount: toKobo(this.loanAccountFormData.interestFreePrincipalAmount),
              applyLoanFees: this.loanAccountFormData.applyLoanFees,
              loanFeesRequest: loanFees,
              loanFees: [],
              allowMoratorium: this.loanAccountFormData.allowMoratorium,
              moratoriumEffect: this.loanAccountFormData.moratoriumEffect,
              moratoriumDuration: this.loanAccountFormData.moratoriumDuration || 0,
              moratoriumFrequency: this.loanAccountFormData.moratoriumFrequency,
            },
          })
          // const totalInterestAmount = `Total Interest Amount = ${toBalance(response.data.totalInterestAmount)}`
          // const totalDays = `Total Days = ${response.data.totalDays}`
          const text1 = this.$t('Total Interest Amount')
          const text2 = this.$t('Total Days')
          const totalInterestAmount = `${text1} = ${toBalance(response.data.totalInterestAmount)}`
          const totalDays = `${text2}  = ${response.data.totalDays}`
          this.computedInterest = `${totalInterestAmount} \n ${totalDays}`

          this.showSpinner = false
          this.showComputedInterest = true
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.showSpinner = false
      }
    },
    onViewSignatoryMandate() {
      this.$root.$emit('bv::show::modal', 'signatory-mandate-table')
    },
    async onViewRepaymentSchedule() {
      try {
        if (this.loanAccountFormData.applyLoanFees && !this.loanAccountFormData.loanFees.length) {
          this.alertError({ text: this.$t('Please select applicable loan fees') })
        } else {
          this.showSpinner = true
          const loanFees = this.loanAccountFormData.loanFees.length
            ? this.loanAccountFormData.loanFees.map(item => {
              if (typeof item !== 'object') {
                return { loanFeeCode: item }
              }
              return { loanFeeCode: item.value }
            }) : []
          const response = await this.getPaymentSchedule({
            permission: accountPermissions.VIEW_ABRIDGED_LOAN,
            formData: {
              accountNumber: this.loanAccountFormData.accountNumber,
              name: this.loanAccountFormData.customerName,
              customerID: this.loanAccountFormData.customerID,
              productCode: this.loanAccountFormData.productCode.value.toString(),
              linkedNumber: this.loanAccountFormData.linkedNumber,
              principalToBeRepaidEvery: this.loanAccountFormData.toBeRepaidEvery ? this.loanAccountFormData.toBeRepaidEvery : 1,
              principalInstallment: this.loanAccountFormData.numberOfInstallment,
              interestToBeRepaidEvery: this.loanAccountFormData.toBeRepaidEvery ? this.loanAccountFormData.toBeRepaidEvery : 1,
              interestInstallment: this.loanAccountFormData.numberOfInstallment,
              penaltyGracePeriod: this.loanAccountFormData.penaltyGracePeriod,
              loanAmount: toKobo(this.loanAccountFormData.loanAmount),
              approvedDate: this.loanAccountFormData.approvedDate,
              interestCommencementDate: this.loanAccountFormData.interestCommencementDate ? toYearWithDate(this.loanAccountFormData.interestCommencementDate) : null,
              startDate: toYearWithDate(this.loanAccountFormData.startDate),
              firstRepaymentDate: this.loanAccountFormData.firstRepaymentDate ? toYearWithDate(this.loanAccountFormData.firstRepaymentDate) : null,
              endDate: this.loanAccountFormData.endDate,
              principalRepaymentType: this.loanAccountFormData.repaymentOption,
              principalFrequency: this.loanAccountFormData.repaymentFrequency,
              applicableInterestCode: this.loanAccountFormData.applicableInterestCode.value,
              useProductInterestRate: this.loanAccountFormData.useProductInterestRate,
              applicableInterestRate: this.loanAccountFormData.applicableInterestRate,
              defaultingInterestRate: this.loanAccountFormData.defaultingInterestRate,
              interestRepaymentType: this.loanAccountFormData.repaymentOption,
              interestFrequency: this.loanAccountFormData.repaymentFrequency,
              interestAccrualMode: this.loanAccountFormData.interestAccrualMode,
              interestFreePrincipalAmount: toKobo(this.loanAccountFormData.interestFreePrincipalAmount),
              applyLoanFees: this.loanAccountFormData.applyLoanFees,
              loanFeesRequest: loanFees,
              loanFees: [],
              allowMoratorium: this.loanAccountFormData.allowMoratorium,
              moratoriumEffect: this.loanAccountFormData.moratoriumEffect,
              moratoriumDuration: this.loanAccountFormData.moratoriumDuration || 0,
              moratoriumFrequency: this.loanAccountFormData.moratoriumFrequency,
            },
          })
          const { status, data } = response
          if (status === 200) {
            this.repaymentSchedules = data.data.map(item => ({
              ...item,
              fee: toBalance(item.fee),
              interest: toBalance(item.interest),
              paymentDate: toDateWithMonth(item.paymentDate),
              paymentStatus: addSpaceToString(item.paymentStatus),
              principal: toBalance(item.principal),
              totalRepayment: toBalance(item.totalRepayment),
            }))
            this.newRepaymentSchedules = data.data.map(item => ({
              ...item,
              fee: item.fee,
              interest: item.interest,
              paymentDate: toDateWithMonth(item.paymentDate),
              paymentStatus: addSpaceToString(item.paymentStatus),
              principal: item.principal,
              totalRepayment: item.totalRepayment,
            }))
            this.repaymentSchedulePagination.totalEntries = data.recordCount
            this.showSpinner = false
            this.$root.$emit('bv::show::modal', 'repayment-schedule-modal')
          }
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.showSpinner = false
      }
    },

    async fetchLoanFee() {
      try {
        const response = await this.getLoanFees({
          search: '',
          page: 0,
          limit: 0,
          permission: accountPermissions.VIEW_ABRIDGED_LOAN,
        })
        const { status, data } = await response
        if (status === 200) {
          this.loanFeeOptions = data.data.reduce((acc, curr) => [...acc, { label: `${curr.name} - ${curr.amount}`, value: curr.code }], [])
        }
      } catch (error) {
        this.toastAlert({ title: `${error}` })
      }
    },

    setApplyLoanFee(value) {
      if (!value) {
        this.loanAccountFormData.loanFees = []
        return false
      }
      return true
    },
    handleSubmit() {
      this.confirm(this.abridgeLoanAccountAction, { text: this.$t('Are you sure you want to create this Abridge Loan Account?') })
    },
    async abridgeLoanAccountAction() {
      try {
        this.isLoading = true
        const loanFees = this.loanAccountFormData.loanFees !== null
          ? this.loanAccountFormData.loanFees.map(item => {
            if (typeof item !== 'object') {
              return { loanFeeCode: item }
            }
            return { loanFeeCode: item.value }
          }) : []
        const nokRelationship = this.typeOfRelationship !== '' ? this.typeOfRelationship : this.customerInformationFormData.nokRelationship
        const formData = {
          customerInformation: {
            ...this.customerInformationFormData,
            nokRelationship,
            dateOfBirth: this.customerInformationFormData.dateOfBirth ? toYearWithDate(this.customerInformationFormData.dateOfBirth) : null,
            meansOfIdentificationExpiryDate: this.customerInformationFormData.meansOfIdentificationExpiryDate ? toYearWithDate(this.customerInformationFormData.meansOfIdentificationExpiryDate) : null,
            meansOfIdentificationIssueDate: this.customerInformationFormData.meansOfIdentificationIssueDate ? toYearWithDate(this.customerInformationFormData.meansOfIdentificationIssueDate) : null,
            nokDateOfBirth: this.customerInformationFormData.nokDateOfBirth ? toYearWithDate(this.customerInformationFormData.nokDateOfBirth) : null,
            employeePayDate: this.customerInformationFormData.employeePayDate ? toYearWithDate(this.customerInformationFormData.employeePayDate) : null,
            employmentDate: this.customerInformationFormData.employmentDate ? toYearWithDate(this.customerInformationFormData.employmentDate) : null,
            employeeIDNetIncome: this.customerInformationFormData.employeeIDNetIncome ? toKobo(this.customerInformationFormData.employeeIDNetIncome) : null,
          },
          customerAccount: {
            ...this.customerAccountFormData,
            productCode: this.customerAccountFormData.productCode.value.toString(),
            productName: this.customerAccountFormData.productCode.label,
            branchCode: this.customerAccountFormData.branchCode.value.toString(),
            branchName: this.customerAccountFormData.branchCode.label,
            accountOfficerCode: this.customerAccountFormData.accountOfficerCode.value.toString(),
            accountOfficerName: this.customerAccountFormData.accountOfficerCode.label,
          },
          loanAccount: {
            ...this.loanAccountFormData,
            loanFees,

            productCode: this.loanAccountFormData.productCode.value.toString(),
            productName: this.loanAccountFormData.productCode.label,
            branchCode: this.loanAccountFormData.branchCode.value.toString(),
            branchName: this.loanAccountFormData.branchCode.label,
            accountOfficerCode: this.loanAccountFormData.accountOfficerCode.value.toString(),
            accountOfficerName: this.loanAccountFormData.accountOfficerCode.label,
            economicSector: this.loanAccountFormData.economicSector.value.toString(),
            economicSectorName: this.loanAccountFormData.economicSector.label,
            applicableInterestCode: this.loanAccountFormData.applicableInterestCode.value.toString(),
            applicableInterestName: this.loanAccountFormData.applicableInterestCode.label,

            loanAmount: this.loanAccountFormData.loanAmount ? toKobo(this.loanAccountFormData.loanAmount) : '',
            applicableInterestRate: this.loanAccountFormData.applicableInterestRate ? toKobo(this.loanAccountFormData.applicableInterestRate) : '',
            startDate: this.loanAccountFormData.startDate ? toYearWithDate(this.loanAccountFormData.startDate) : null,
            interestCommencementDate: this.loanAccountFormData.interestCommencementDate ? toYearWithDate(this.loanAccountFormData.interestCommencementDate) : null,
            toBeRepaidEvery: this.loanAccountFormData.toBeRepaidEvery ? this.loanAccountFormData.toBeRepaidEvery : 1,
          },
          documentIdentifier: this.documentIdentifier,
        }
        const response = await this.createAbridgeLoanAccount({ formData, permission: accountPermissions.ABRIDGED_LOAN })
        const { status } = response
        if (status === 200) {
          this.hideModal('modal-lg')
          this.alertSuccess({ text: this.$t('Your request to Create Abridge loan was successful') })
          this.$router.push({ name: 'loan-list' })
          this.isReadonly = true
        }
      } catch (error) {
        const errorMesg = this.$t('Your request to Create Abridge loan failed, Reason:')
        error.response.data.errors.forEach(responseError => {
          this.alertError({ text: `${errorMesg} ${responseError.errorMessage}` })
        })
      } finally {
        this.isLoading = false
      }
    },

    validatePersonal() {
      return new Promise((resolve, reject) => {
        this.$refs.personalInfoRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validateContactDetails() {
      return new Promise((resolve, reject) => {
        this.$refs.contactDetailsRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validateNextOfKin() {
      return new Promise((resolve, reject) => {
        this.$refs.nextOfKinRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validateEmployeeDetail() {
      return new Promise((resolve, reject) => {
        this.$refs.employeeDetailRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validateLoanServicingDetail() {
      return new Promise((resolve, reject) => {
        this.$refs.loanServicingRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validateLoanDetail() {
      return new Promise((resolve, reject) => {
        this.$refs.loanDetailRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validatUploads() {
      return new Promise((resolve, reject) => {
        this.$refs.uploadRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.upload-image{
    border: 2px dashed #DCD9D9;
    position: relative;
    width: 250px;
    height: 250px
}
.format {
    color: #999999 !important;
}
form input[type=file]{
  position: absolute;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  outline: none;
  opacity: 0;
}
.upload-instruction{
  padding-top: 22%;
  color: #000;
  text-align: center;
}
.trash {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  background: #fff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-right: 10px;
  cursor: pointer;
}
.view-details {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  background: #fff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-left: 10px;
  cursor: pointer;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/base/bootstrap-extended/_include.scss';
</style>
